export const ROUTES = {
  home: "/",
  curriculo: "/curriculo",
  hipnoterapia: "/hipnoterapia",
  superAprendizagem: "/super-aprendizagem",
  formacao: "/formacao",
  proBono: "/pro-bono",
  psicologia: "/psicologia",
  livroManual: "/livros/manual-para-professores",
  livroSerMaior: "/livros/ser-maior",
  privacidade: "/privacidade",
  termos: "/termos-e-condicoes",
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];
